import { Dropdown } from "Components/Shared/Inputs/Form/Dropdown";
import { useExpectedMonthlyRevenueList } from "Hooks/Options/useExpectedMonthlyRevenueList";
import type { Control, FieldPath, FieldValues } from "react-hook-form";

type Props<FormType extends FieldValues, TransformedFieldValues = FormType> = {
  name: FieldPath<FormType>;
  control: Control<FormType, unknown, TransformedFieldValues>;
  label?: string;
};

export const ExpectedMonthlyRevenueDropdown = <
  T extends object,
  V extends object,
>({
  control,
  name,
  label,
}: Props<T, V>) => {
  const codeList = useExpectedMonthlyRevenueList();

  return (
    <Dropdown codeList={codeList} name={name} control={control} label={label} />
  );
};
